/* eslint-disable react/jsx-no-duplicate-props */
/* eslint-disable no-unused-vars */
import { useEffect, useMemo } from 'react';

import { Button, Modal, Popover } from 'antd';
import queryString from 'query-string';
import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { ExclamationCircleFilled } from '@ant-design/icons';

import { useLocation } from 'react-router-dom';
import TableColumnSearch from '../../../components/Input/TableColumnSearch';
import { TableListPageCom } from '../../../components/TableListPageCom';
import { ActionDeleteMemberShip, ActionGetMemberShipList } from '../../../store/Actions/MasterDataAction';
import { ResponsiveComponent } from '../../../utils/functions';
import { matchPermissions } from '../../../utils/Permission';
import { PERMISSIONS } from '../../../constants';

const { confirm } = Modal;

const MemberShip = () => {
  const { loader, memberShip } = useSelector(state => state?.MasterData);
  const { userDetails } = useSelector(state => state?.auth);
  const [showArrow, setShowArrow] = useState(true);
  const [Refresh, setRefresh] = useState(false);
  const [arrowAtCenter, setArrowAtCenter] = useState(false);
  const [IsSearching, setIsSearching] = useState(false);
  const pageSize = 10;
  const dispatch = useDispatch();
  const location = useLocation();
  const params = queryString.parse(location.search);
  const Size = ResponsiveComponent();
  const [searchText, setSearchText] = useState('');
  const [searchedColumn, setSearchedColumn] = useState('');
  const [SearchList, setSearchList] = useState([]);
  const mergedArrow = useMemo(() => {
    if (arrowAtCenter)
      return {
        pointAtCenter: true,
      };
    return showArrow;
  }, [showArrow, arrowAtCenter]);
  const handleSearch = (selectedKeys, dataIndex) => {
    setSearchText(selectedKeys?.[0]);
    setSearchedColumn(dataIndex);

    if (params[dataIndex]) {
      window.location.replace(
        `/member-ship?page=1&filterlist=true&${dataIndex}=${selectedKeys?.[0]}`
      );
    } else {
      window.location.replace(`/member-ship?${location.search}&${dataIndex}=${selectedKeys?.[0]}`);
    }
  };
  const handleReset = clearFilters => {
    clearFilters();
    setSearchText('');
    window.location.replace(`?page=1`);
  };
  const matchPermissionsForUser = matchPermissions(userDetails);
  const canView = matchPermissionsForUser(PERMISSIONS.MASTER_DATA.MEMBERSHIP.VIEW);
  const canUpdate = matchPermissionsForUser(PERMISSIONS.MASTER_DATA.MEMBERSHIP.UPDATE);
  const canDelete = matchPermissionsForUser(PERMISSIONS.MASTER_DATA.MEMBERSHIP.DELETE);
  const canCerate = matchPermissionsForUser(PERMISSIONS.MASTER_DATA.MEMBERSHIP.CREATE);

  const content = item => (
    <div className="">
      {canUpdate && (
        <Button className="m-2" onClick={() => EditList(item?.id)}>
          Edit
        </Button>
      )}
      {canDelete && <Button onClick={() => showDeleteConfirm(item)}>Delete</Button>}
    </div>
  );
  const columns = [
    {
      title: 'Sr',
      dataIndex: 'sr',
      // key: "Sr",
      render: (text, record, index) => {
        const currentPage = parseInt(params?.page) || 1;
        const calculatedIndex = (currentPage - 1) * pageSize + index + 1;
        return <span>{calculatedIndex}</span>;
      },
    },
    {
      title: 'Order Index',
      dataIndex: 'orderIndex',
      render: (text, record) => <span>{record.orderIndex}</span>,
      ...TableColumnSearch({
        dataIndex: 'orderIndex',
        setSearchText,
        setSearchedColumn,
        handleReset,
        handleSearch,
      }),
    },
    {
      title: 'Membership Type',
      dataIndex: 'memberShipType',
      render: (text, record) => <span>{record.memberShipType}</span>,
      ...TableColumnSearch({
        dataIndex: 'memberShipType',
        setSearchText,
        setSearchedColumn,
        handleReset,
        handleSearch,
        filtered: params?.memberShipType,
      }),
      sorter: (a, b) => a.memberShipType.length - b.memberShipType.length,
    },
    {
      title: !canDelete && !canUpdate ? null : 'Action',
      dataIndex: 'id',
      key: 'action',
      render: (text, record, num) => {
        if (!canDelete && !canUpdate) {
          return null;
        } else {
          return (
            <Popover
              placement="left"
              title={record.memberShipType}
              content={() => content(record)}
              arrow={mergedArrow}
            >
              <Button type="dashed">• • •</Button>
            </Popover>
          );
        }
      },
    },
  ];
  // const OrderIndex = params?.orderIndex ? `&orderIndex=${params?.orderIndex}` : ''
  // const Title = params?.title ? `&title=${params?.title}` : ''
  // const Final = OrderIndex + Title || ''

  useEffect(() => {
    dispatch(ActionGetMemberShipList({ Query: `?page=${params?.page || 1}` }));
    setRefresh(false);
  }, [dispatch, params?.page, Refresh]);

  const handleSearch1 = searchTerm => {
    var newp = params;
    newp.page = searchTerm;
    window.location.href = window.location.pathname + '?' + queryString.stringify(newp);
  };

  const EditList = searchTerm => {
    window.location.href = `/member-ship/add-member-ship?update=true&&id=${searchTerm}&&page=${parseInt(params.page)}`;
  };

  const showDeleteConfirm = item => {
    confirm({
      title: `Are you sure delete this ${item?.memberShipType}?`,
      icon: <ExclamationCircleFilled />,
      content: '',
      okText: 'Yes',
      okType: 'danger',
      cancelText: 'No',
      zIndex: 1200,
      centered: true,
      onOk() {
        dispatch(
          ActionDeleteMemberShip('/' + item?.id, Res => {
            if (Res === 200) {
              setRefresh(true);
            }
          })
        );
      },
      onCancel() {
        return
      },
    });
  };
  const BreadcrumbList = [
    {
      name: 'Member Ship',
      linkTo: `/member-ship?page=${params?.page || 1}`,
    },
    {
      name: 'Member Ship List',
    },
  ];
  return canView ? (
    <TableListPageCom
      BreadcrumbList={BreadcrumbList}
      TableData={memberShip?.docs}
      TableColumn={columns}
      ShowAddButton={true}
      Iscreate={PERMISSIONS.MASTER_DATA.MEMBERSHIP.CREATE}
      CreateButtonLink={`/member-ship/add-member-ship?update=false&&page=${params?.page || 1}`}
      PageMainTitle="Member Ship List"
      CurrentPage={memberShip?.page || 1}
      Tableloader={loader}
      TotalPageList={memberShip?.totalDocs}
      dataSourceLength={memberShip?.docs?.length}
      handlePageChange={v => {
        var newp = params;
        newp.page = v;
        window.location.href = window.location.pathname + '?' + queryString.stringify(newp);
      }}
    />
  ) : (
    <div className="permission-denied-message">
      You do not have permission to view Member Ship list.
    </div>
  );

};

export default MemberShip;
